import { ProjectFromAPI } from '../types';
import { transformProjectResponse } from './api-transforms';
import apiRequest from './apiRequest';

type ProjectPutPayload = {
  projectName?: string;
  characters?: Record<string, any>;
  poseID?: string;
  sceneSettingsID?: string;
  type?: 'POSE' | 'MIXED';
  sceneSettings?: any;
};

export default async function putProject(
  projectID: string,
  props: ProjectPutPayload,
) {
  const { data, error } = await apiRequest<ProjectFromAPI>(
    'mogen-orchestration',
    `/v2/projects/${projectID}`,
    {
      method: 'PUT',
      body: JSON.stringify(props),
    },
  );

  return { data: transformProjectResponse(data), error };
}
